import firebase from 'firebase';

// Your web app's Firebase configuration
var firebaseConfig = {
    apiKey: "AIzaSyCIoAoIOPeIzExCGzXI3qy6yXz1bfCrBb8",
    authDomain: "tech4humans-edfaf.firebaseapp.com",
    projectId: "tech4humans-edfaf",
    storageBucket: "tech4humans-edfaf.appspot.com",
    messagingSenderId: "72608299657",
    appId: "1:72608299657:web:b0f86d6d8a7b2280706458",
    measurementId: "G-ZSK57SGBRG"
};
 
  // Initialize Firebase
  firebase.initializeApp(firebaseConfig);

export default firebase;